export default __webpack_public_path__ + "static/media/success-icon.e9e32f82.svg";